<template>
  <div class="activeContent">
    <div v-if="currentActiveContent == home">
      <Dashboard :userData="userData" :organizationData="organizationData" />
    </div>
    <div v-else-if="currentActiveContent == gate">
      <div v-if="currentSubPage == 'Entry Log'">
        <EntryLog :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == 'Frequent Visitors'">
        <FrequentVisitors :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == 'Blocked List'">
        <BlockedVisitors :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == 'Vendors'">
        <Vendors :userData="userData"   :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else>
        <Gate :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
    </div>
    <div v-else-if="currentActiveContent == enforcement">
      <div v-if="currentSubPage == incidents">
        <Incidents :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == violations">
        <Violations :userData="userData"   :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else>
        <Incidents :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
    </div>
    <div v-else-if="currentActiveContent == analytics">
      <Reporting :userData="userData"  :organizationData="organizationData" />
    </div>
    <!-- <div v-else-if="currentActiveContent == users">
      <Users :subPage="currentSubPage"/>
    </div> -->
    <div v-else-if="currentActiveContent == users">
      <div v-if="currentSubPage == 'Resident Directory'">
        <ResidentDirectory :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == 'Units'">
        <Units :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == 'Vehicles'">
        <Vehicles :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == 'Pets'">
        <Pets :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else-if="currentSubPage == 'Vendors'">
        <Vendors :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
      <div v-else>
        <Users :userData="userData"  :subPage="currentSubPage" :organizationData="organizationData" />
      </div>
    </div>
    <div v-else-if="currentActiveContent == maintenance">
      <Maintenance :userData="userData" :organizationData="organizationData" />
    </div>
    <div v-else-if="currentActiveContent == accounting">
      <Accounting :userData="userData" :organizationData="organizationData" />
    </div>
    <div v-else-if="currentActiveContent == communications">
      <Communications :userData="userData" :subPage="currentSubPage" :organizationData="organizationData" />
    </div>
    <div v-else-if="currentActiveContent == support">
      <NewSettings :userData="userData" :organizationData="organizationData" />
    </div>
  </div>
</template>

<script>
import Dashboard from "./pages/Dashboard";
import Gate from "./pages/Gate.vue";
import EventBus from "../eventBus";
import * as Constants from "../js/constants";
import Reporting from "./pages/Reporting.vue";
import Incidents from "./pages/Incidents.vue";
import Users from "./pages/Users.vue"
import Maintenance from "./pages/Maintenance.vue";
import Accounting from "./pages/Accounting.vue";
import Communications from "./pages/Communications.vue";
//import Settings from "./pages/Settings.vue";
import EntryLog from "./pages/visitorManagement/EntryLog.vue";
import FrequentVisitors from "./pages/visitorManagement/FrequentVisitors.vue";
import BlockedVisitors from "./pages/visitorManagement/BlockedVisitors.vue";
import Vendors from "./pages/visitorManagement/Vendors.vue";
import Vehicles from "./pages/directory/Vehicles.vue";
import Pets from "./pages/directory/Pets.vue";
import ResidentDirectory from "./pages/directory/ResidentDirectory.vue";
import Violations from "./pages/enforcement/Violations.vue";
import NewSettings from "./pages/settings/NewSettings.vue";
import Units from "./pages/directory/Units.vue";

export default {
  name: "ActiveContent",
  components: {
    Dashboard,
    Gate,
    EntryLog,
    FrequentVisitors,
    BlockedVisitors,
    Vendors,
    Reporting,
    Incidents,
    Violations,
    Users,
    Units,
    Vehicles,
    Pets,
    ResidentDirectory,
    Maintenance,
    Accounting,
    Communications,
    //Settings,
    NewSettings
  },
  props: ['userData', 'organizationData'],
  data() {
    return {
      currentActiveContent: Constants.HOME,
      currentSubPage: "",
      home: Constants.HOME,
      gate: Constants.GATE,
      incidents: Constants.INCIDENTS,
      violations: Constants.VIOLATIONS,
      enforcement: Constants.ENFORCEMENT,
      analytics: Constants.ANALYTICS,
      users: Constants.USERS,
      maintenance: Constants.MAINTENANCE,
      accounting: Constants.ACCOUNTING,
      communications: Constants.EVENTSANDCOMMUNICATIONS,
      support: Constants.SUPPORT,
    };
  },
  created() {
    var eventTitle = Constants.NAVIGATION_ITEM_SELECTED;
    EventBus.$on(eventTitle, (data) => {
      this.showContent(data);
    });
    const path = window.location.pathname;
    console.log("Active Content.vue querystring", path);
    const filteredPath = path.replace('/', '')
    this.showContent(filteredPath)
  },
  methods: {
    showContent(data) {
      console.log("Show Content:", data);
      window.scrollTo(0, 0)
      let pathParts = []
      let pathToNavigate
      if (data.includes('/')) {
        pathToNavigate = data.substring(0, data.indexOf('/'))
        pathParts = data.split('/')
        // pathToNavigate = data

      } else {
        pathToNavigate = data
        pathToNavigate = data
        pathParts = Array.of(data)
      }
      pathToNavigate = decodeURI(pathToNavigate)
      console.log("pathToNavigate data", data)
      console.log("pathToNavigate", pathToNavigate, "parts", pathParts)
      switch (pathToNavigate) {
        default: {
          this.showPage(pathParts);
          break;
        }
      }
    },
    showPage(path) {
      console.log("Active Content", `Show ${path}`)
      const rootPath = decodeURI(path[0])
      const subPage = path[1] ? decodeURI(path[1]) : null
      let finalPath;
      if (rootPath == "" || rootPath == null) {
        finalPath = Constants.HOME
      } else {
        finalPath = rootPath
      }
      console.log("Active Content Path and Page", finalPath, subPage)
      this.currentActiveContent = finalPath;
      if (subPage != null) {
        this.currentSubPage = subPage
      }

    },
    showSupport() {
      console.log("Active Content", "Show Users");
      let url = "https://communitytech-support.atlassian.net/servicedesk/customer/portals"
      window.open(url, '_blank').focus();
    },
  },
};
</script>

<style scoped>
.activeContent {
  width: 100%;
  height: 100%;
  padding-left: 32px;
  padding-right: 32px;
  background-color: #f2f2f2;
  display: block;
}
</style>